// DO NOT EDIT -- generated from fs/services/alexa/searchies.proto

import { DatumWithSegmentDefinition, MultiDatum } from './search.proto';
import * as cookerr from '../../cook/cookerr';
import * as protobuf from '../../../google/protobuf';
import * as search from '../../api/search';
import * as segment from '../../api/segment';
import * as vars from '../../api/vars';

export enum SearchieType {
  SEARCHIE_TYPE_INVALID = 0,
  SEARCHIE_TYPE_TOP_ERROR_CLICKS = 1,
  SEARCHIE_TYPE_TOP_RAGE_CLICKS = 2,
  SEARCHIE_TYPE_TOP_DEAD_CLICKS = 3,
  SEARCHIE_TYPE_TRAFFIC_BY_REFERER_HOST = 4,
  SEARCHIE_TYPE_TRAFFIC_BY_UTM_SOURCE = 5,
  SEARCHIE_TYPE_TRAFFIC_BY_UTM_CAMPAIGN = 6,
  SEARCHIE_TYPE_TRAFFIC_BY_UTM_MEDIUM = 7,
  SEARCHIE_TYPE_TRAFFIC_BY_BROWSER = 8,
  SEARCHIE_TYPE_DEVICE_BREAKDOWN = 9,
  SEARCHIE_TYPE_EVENT_FUNNEL = 10,
  SEARCHIE_TYPE_MOST_ACTIVE_USERS = 11,
  SEARCHIE_TYPE_SEGMENT_HEALTH = 12,
  SEARCHIE_TYPE_TOP_PAGES = 13,
  SEARCHIE_TYPE_RAGE_GRADE = 14,
  SEARCHIE_TYPE_ACTIVITY_SUMMARY = 15,
  SEARCHIE_TYPE_DAILY_ACTIVES = 16,
  SEARCHIE_TYPE_MATCHING_USERS = 17,
  SEARCHIE_TYPE_TIME_RANGE_COUNTS = 18,
  SEARCHIE_TYPE_FEEDBACK = 19,
  SEARCHIE_TYPE_SCREEN_RESOLUTIONS = 20,
  SEARCHIE_TYPE_SLOW_PAGES = 21,
  SEARCHIE_TYPE_MOBILE_DEVICES = 22,
  SEARCHIE_TYPE_MOBILE_APP_VERSIONS = 23,
  SEARCHIE_TYPE_MOBILE_RESOLUTIONS = 24,
  SEARCHIE_TYPE_MOBILE_OS_VERSIONS = 25,
  SEARCHIE_TYPE_API_ERRORS = 26,
  SEARCHIE_TYPE_MOST_COMMON_ENTRY_PAGES = 27,
  SEARCHIE_TYPE_USER_TRENDS_CARD = 28
}

/** Handle on search criteria and other settings representing an individual searchie. */
export interface SearchieHandle {
  type: SearchieType;
  topErrorClicksSettings?: SearchieTopBadClicksSettings | null;
  topRageClicksSettings?: SearchieTopBadClicksSettings | null;
  topDeadClicksSettings?: SearchieTopBadClicksSettings | null;
  segmentHealthSettings?: SearchieSegmentHealthSettings | null;
  dailyActivesSettings?: SearchieDailyActivesSettings | null;
  matchingUsersSettings?: SearchieMatchingUsersSettings | null;
  timeRangeCountsSettings?: SearchieTimeRangeCountsSettings | null;
  mobileDevicesSettings?: SearchieMobileDevicesSettings | null;
  userTrendsCardSettings?: SearchieUserTrendsCardSettings | null;
  topPagesSettings?: SearchiePageCardSettings | null;
  slowPagesSettings?: SearchiePageCardSettings | null;
  mostCommonEntryPagesSettings?: SearchiePageCardSettings | null;
  /** Segment definition for this searchie. */
  segmentDefinition: segment.SegmentDefinition | null;
}

/** Handle on search criteria and other settings representing an individual searchie. */
export namespace SearchieHandle {
  /**
   * Type specific settings.
   * Types w/o settings do not have additional configuration past the common top level fields.
   */
  export enum settings {
    topErrorClicksSettings = 2,
    topRageClicksSettings = 3,
    topDeadClicksSettings = 4,
    segmentHealthSettings = 5,
    dailyActivesSettings = 6,
    matchingUsersSettings = 7,
    timeRangeCountsSettings = 8,
    mobileDevicesSettings = 9,
    userTrendsCardSettings = 11,
    topPagesSettings = 13,
    slowPagesSettings = 14,
    mostCommonEntryPagesSettings = 15
  }

  /**
   * Type specific settings.
   * Types w/o settings do not have additional configuration past the common top level fields.
   */
  export function settings_oneof(m: SearchieHandle): { opt: settings.dailyActivesSettings, val: SearchieDailyActivesSettings } | { opt: settings.matchingUsersSettings, val: SearchieMatchingUsersSettings } | { opt: settings.mobileDevicesSettings, val: SearchieMobileDevicesSettings } | { opt: settings.mostCommonEntryPagesSettings, val: SearchiePageCardSettings } | { opt: settings.segmentHealthSettings, val: SearchieSegmentHealthSettings } | { opt: settings.slowPagesSettings, val: SearchiePageCardSettings } | { opt: settings.timeRangeCountsSettings, val: SearchieTimeRangeCountsSettings } | { opt: settings.topDeadClicksSettings, val: SearchieTopBadClicksSettings } | { opt: settings.topErrorClicksSettings, val: SearchieTopBadClicksSettings } | { opt: settings.topPagesSettings, val: SearchiePageCardSettings } | { opt: settings.topRageClicksSettings, val: SearchieTopBadClicksSettings } | { opt: settings.userTrendsCardSettings, val: SearchieUserTrendsCardSettings } | null {
    if (m.topErrorClicksSettings != null) { return { opt: settings.topErrorClicksSettings, val: m.topErrorClicksSettings } }
    if (m.topRageClicksSettings != null) { return { opt: settings.topRageClicksSettings, val: m.topRageClicksSettings } }
    if (m.topDeadClicksSettings != null) { return { opt: settings.topDeadClicksSettings, val: m.topDeadClicksSettings } }
    if (m.segmentHealthSettings != null) { return { opt: settings.segmentHealthSettings, val: m.segmentHealthSettings } }
    if (m.dailyActivesSettings != null) { return { opt: settings.dailyActivesSettings, val: m.dailyActivesSettings } }
    if (m.matchingUsersSettings != null) { return { opt: settings.matchingUsersSettings, val: m.matchingUsersSettings } }
    if (m.timeRangeCountsSettings != null) { return { opt: settings.timeRangeCountsSettings, val: m.timeRangeCountsSettings } }
    if (m.mobileDevicesSettings != null) { return { opt: settings.mobileDevicesSettings, val: m.mobileDevicesSettings } }
    if (m.userTrendsCardSettings != null) { return { opt: settings.userTrendsCardSettings, val: m.userTrendsCardSettings } }
    if (m.topPagesSettings != null) { return { opt: settings.topPagesSettings, val: m.topPagesSettings } }
    if (m.slowPagesSettings != null) { return { opt: settings.slowPagesSettings, val: m.slowPagesSettings } }
    if (m.mostCommonEntryPagesSettings != null) { return { opt: settings.mostCommonEntryPagesSettings, val: m.mostCommonEntryPagesSettings } }
    return null;
  }
}

/** Settings for all Page Cards (Top Pages, Slow Pages, Top Entry Pages) */
export interface SearchiePageCardSettings {
  /**
   * ignored, Searchies will always use page definitions moving forward
   * 
   * @deprecated
   */
  usePageDefs: boolean;
}

export enum SearchieTopBadClicksPivot {
  SEARCHIE_TOP_BAD_CLICKS_PIVOT_INVALID = 0,
  SEARCHIE_TOP_BAD_CLICKS_PIVOT_EVENT = 1,
  SEARCHIE_TOP_BAD_CLICKS_PIVOT_USER = 2
}

export enum SearchieTopBadClicksGroupBy {
  SEARCHIE_TOP_BAD_CLICKS_GROUP_BY_INVALID = 0,
  SEARCHIE_TOP_BAD_CLICKS_GROUP_BY_TARGET_TEXT = 1,
  SEARCHIE_TOP_BAD_CLICKS_GROUP_BY_ELEMENT = 2
}

export interface SearchieTopBadClicksSettings {
  pivot: SearchieTopBadClicksPivot;
  limit: number;
  groupBy: SearchieTopBadClicksGroupBy;
}

export interface SearchieSegmentHealthSettings {
  alignWeekdays: boolean;
}

export enum SearchieDailyActivesFrequency {
  SEARCHIE_DAILY_ACTIVES_FREQUENCY_INVALID = 0,
  SEARCHIE_DAILY_ACTIVES_FREQUENCY_DAILY = 1,
  SEARCHIE_DAILY_ACTIVES_FREQUENCY_WEEKLY = 7,
  SEARCHIE_DAILY_ACTIVES_FREQUENCY_MONTHLY = 30
}

export interface SearchieDailyActivesSettings {
  frequencies: SearchieDailyActivesFrequency[];
  computePast: boolean;
  computeRatio: boolean;
  alignWeekdays: boolean;
}

export interface SearchieUserTrendsCardSettings {
  granularity: IntervalGranularity;
  computePast: boolean;
}

export enum SortOrder {
  SORT_ORDER_INVALID = 0,
  SORT_ORDER_ASC = 1,
  SORT_ORDER_DESC = 2
}

export interface SearchieMatchingUsersSettings {
  start: number;
  limit: number;
  sortOrder: SortOrder;
  /** if true, the matching users event data will come from the earliest matching in the session instead of the latest */
  earliestInSession: boolean;
  /**
   * Populated when we want to generate the user list searchie for the intersection
   * of more than one segment definition. I&I should be the only caller to populate this.
   */
  additionalSegmentDefinitions: segment.SegmentDefinition[];
  /**
   * When event search is supplied, it specifies the exact segment, matching behavior, and select configuration for
   * the API. If supplied, matching events and sessions will be based off of the selected events only in the context
   * of the matching individuals and behavior scope -- of note, selections occur in an unordered fashion after
   * segments and matching behaviors have been constrained and thus many flows for matching users are simplified.
   * If and only if there is a single event scoped matching behaviors and no selected events, the corresponding
   * positive matching behaviors at the event level will be used to mark events.
   * When supplied, neither the top level criteria / segment nor the settings level additional criteria / segments
   * are respected as the event search contains specifications for the entire search.
   */
  eventSearch: search.EventSearch | null;
}

export interface SearchieTimeRangeCountsSettings {
  countMatching: boolean;
}

export enum SearchieMobileDevicesPivot {
  SEARCHIE_MOBILE_DEVICES_PIVOT_INVALID = 0,
  SEARCHIE_MOBILE_DEVICES_PIVOT_VENDOR = 1,
  SEARCHIE_MOBILE_DEVICES_PIVOT_MODEL = 2
}

export interface SearchieMobileDevicesSettings {
  pivot: SearchieMobileDevicesPivot;
}

export interface GeneratedSearchie {
  /**
   * Handle used to generate the searchie.
   * The provided data will correspond to the searchie type provided in the handle.
   */
  handle: SearchieHandle | null;
  topErrorClicksData?: SearchieHistogramData | null;
  topRageClicksData?: SearchieHistogramData | null;
  topDeadClicksData?: SearchieHistogramData | null;
  trafficByRefererHostData?: SearchieHistogramData | null;
  trafficByUtmSourceData?: SearchieHistogramData | null;
  trafficByUtmCampaignData?: SearchieHistogramData | null;
  trafficByUtmMediumData?: SearchieHistogramData | null;
  trafficByBrowserData?: SearchieHistogramData | null;
  deviceBreakdownData?: SearchieHistogramData | null;
  eventFunnelData?: SearchieEventFunnelData | null;
  mostActiveUsersData?: SearchieMostActiveUsersData | null;
  segmentHealthData?: SearchieSegmentHealthData | null;
  topPagesData?: SearchieTopPagesData | null;
  rageGradeData?: SearchieRageGradeData | null;
  activitySummaryData?: SearchieActivitySummaryData | null;
  dailyActivesData?: SearchieDailyActivesData | null;
  matchingUsersData?: SearchieMatchingUsersData | null;
  timeRangeCountsData?: SearchieTimeRangeCountsData | null;
  /** client only right now */
  feedbackData?: {} | null;
  screenResolutionsData?: SearchieHistogramData | null;
  slowPagesData?: SearchieSlowPagesData | null;
  mobileDevicesData?: SearchieHistogramData | null;
  mobileAppVersionsData?: SearchieHistogramData | null;
  mobileResolutionsData?: SearchieHistogramData | null;
  mobileOsVersionsData?: SearchieHistogramData | null;
  apiErrorsData?: SearchieApiErrorsData | null;
  mostCommonEntryPagesData?: SearchieMostCommonEntryPagesData | null;
  userTrendsCardData?: SearchieUserTrendsCardData | null;
}

export namespace GeneratedSearchie {
  export enum data {
    topErrorClicksData = 2,
    topRageClicksData = 3,
    topDeadClicksData = 4,
    trafficByRefererHostData = 5,
    trafficByUtmSourceData = 6,
    trafficByUtmCampaignData = 7,
    trafficByUtmMediumData = 8,
    trafficByBrowserData = 9,
    deviceBreakdownData = 10,
    eventFunnelData = 11,
    mostActiveUsersData = 12,
    segmentHealthData = 13,
    topPagesData = 14,
    rageGradeData = 15,
    activitySummaryData = 16,
    dailyActivesData = 17,
    matchingUsersData = 18,
    timeRangeCountsData = 19,
    /** client only right now */
    feedbackData = 20,
    screenResolutionsData = 21,
    slowPagesData = 22,
    mobileDevicesData = 23,
    mobileAppVersionsData = 24,
    mobileResolutionsData = 25,
    mobileOsVersionsData = 26,
    apiErrorsData = 27,
    mostCommonEntryPagesData = 28,
    userTrendsCardData = 29
  }

  export function data_oneof(m: GeneratedSearchie): { opt: data.activitySummaryData, val: SearchieActivitySummaryData } | { opt: data.apiErrorsData, val: SearchieApiErrorsData } | { opt: data.dailyActivesData, val: SearchieDailyActivesData } | { opt: data.deviceBreakdownData, val: SearchieHistogramData } | { opt: data.eventFunnelData, val: SearchieEventFunnelData } | { opt: data.feedbackData, val: {} } | { opt: data.matchingUsersData, val: SearchieMatchingUsersData } | { opt: data.mobileAppVersionsData, val: SearchieHistogramData } | { opt: data.mobileDevicesData, val: SearchieHistogramData } | { opt: data.mobileOsVersionsData, val: SearchieHistogramData } | { opt: data.mobileResolutionsData, val: SearchieHistogramData } | { opt: data.mostActiveUsersData, val: SearchieMostActiveUsersData } | { opt: data.mostCommonEntryPagesData, val: SearchieMostCommonEntryPagesData } | { opt: data.rageGradeData, val: SearchieRageGradeData } | { opt: data.screenResolutionsData, val: SearchieHistogramData } | { opt: data.segmentHealthData, val: SearchieSegmentHealthData } | { opt: data.slowPagesData, val: SearchieSlowPagesData } | { opt: data.timeRangeCountsData, val: SearchieTimeRangeCountsData } | { opt: data.topDeadClicksData, val: SearchieHistogramData } | { opt: data.topErrorClicksData, val: SearchieHistogramData } | { opt: data.topPagesData, val: SearchieTopPagesData } | { opt: data.topRageClicksData, val: SearchieHistogramData } | { opt: data.trafficByBrowserData, val: SearchieHistogramData } | { opt: data.trafficByRefererHostData, val: SearchieHistogramData } | { opt: data.trafficByUtmCampaignData, val: SearchieHistogramData } | { opt: data.trafficByUtmMediumData, val: SearchieHistogramData } | { opt: data.trafficByUtmSourceData, val: SearchieHistogramData } | { opt: data.userTrendsCardData, val: SearchieUserTrendsCardData } | null {
    if (m.topErrorClicksData != null) { return { opt: data.topErrorClicksData, val: m.topErrorClicksData } }
    if (m.topRageClicksData != null) { return { opt: data.topRageClicksData, val: m.topRageClicksData } }
    if (m.topDeadClicksData != null) { return { opt: data.topDeadClicksData, val: m.topDeadClicksData } }
    if (m.trafficByRefererHostData != null) { return { opt: data.trafficByRefererHostData, val: m.trafficByRefererHostData } }
    if (m.trafficByUtmSourceData != null) { return { opt: data.trafficByUtmSourceData, val: m.trafficByUtmSourceData } }
    if (m.trafficByUtmCampaignData != null) { return { opt: data.trafficByUtmCampaignData, val: m.trafficByUtmCampaignData } }
    if (m.trafficByUtmMediumData != null) { return { opt: data.trafficByUtmMediumData, val: m.trafficByUtmMediumData } }
    if (m.trafficByBrowserData != null) { return { opt: data.trafficByBrowserData, val: m.trafficByBrowserData } }
    if (m.deviceBreakdownData != null) { return { opt: data.deviceBreakdownData, val: m.deviceBreakdownData } }
    if (m.eventFunnelData != null) { return { opt: data.eventFunnelData, val: m.eventFunnelData } }
    if (m.mostActiveUsersData != null) { return { opt: data.mostActiveUsersData, val: m.mostActiveUsersData } }
    if (m.segmentHealthData != null) { return { opt: data.segmentHealthData, val: m.segmentHealthData } }
    if (m.topPagesData != null) { return { opt: data.topPagesData, val: m.topPagesData } }
    if (m.rageGradeData != null) { return { opt: data.rageGradeData, val: m.rageGradeData } }
    if (m.activitySummaryData != null) { return { opt: data.activitySummaryData, val: m.activitySummaryData } }
    if (m.dailyActivesData != null) { return { opt: data.dailyActivesData, val: m.dailyActivesData } }
    if (m.matchingUsersData != null) { return { opt: data.matchingUsersData, val: m.matchingUsersData } }
    if (m.timeRangeCountsData != null) { return { opt: data.timeRangeCountsData, val: m.timeRangeCountsData } }
    if (m.feedbackData != null) { return { opt: data.feedbackData, val: m.feedbackData } }
    if (m.screenResolutionsData != null) { return { opt: data.screenResolutionsData, val: m.screenResolutionsData } }
    if (m.slowPagesData != null) { return { opt: data.slowPagesData, val: m.slowPagesData } }
    if (m.mobileDevicesData != null) { return { opt: data.mobileDevicesData, val: m.mobileDevicesData } }
    if (m.mobileAppVersionsData != null) { return { opt: data.mobileAppVersionsData, val: m.mobileAppVersionsData } }
    if (m.mobileResolutionsData != null) { return { opt: data.mobileResolutionsData, val: m.mobileResolutionsData } }
    if (m.mobileOsVersionsData != null) { return { opt: data.mobileOsVersionsData, val: m.mobileOsVersionsData } }
    if (m.apiErrorsData != null) { return { opt: data.apiErrorsData, val: m.apiErrorsData } }
    if (m.mostCommonEntryPagesData != null) { return { opt: data.mostCommonEntryPagesData, val: m.mostCommonEntryPagesData } }
    if (m.userTrendsCardData != null) { return { opt: data.userTrendsCardData, val: m.userTrendsCardData } }
    return null;
  }
}

export enum SearchieCountType {
  SEARCHIE_COUNT_TYPE_INVALID = 0,
  SEARCHIE_COUNT_TYPE_USER = 1,
  SEARCHIE_COUNT_TYPE_SESSION = 2,
  SEARCHIE_COUNT_TYPE_EVENT = 3,
  SEARCHIE_COUNT_TYPE_CLICK = 4
}

export interface Histogram {
  data: DatumWithSegmentDefinition[];
  /** optionally set based on use case */
  countType: SearchieCountType;
  /** optionally set based on use case, when not present, a reliable total could not be determined */
  totalCount: number;
}

export interface Funnel {
  data: DatumWithSegmentDefinition[];
}

export enum IntervalGranularity {
  INTERVAL_GRANULARITY_INVALID = 0,
  INTERVAL_GRANULARITY_YEAR = 1,
  INTERVAL_GRANULARITY_MONTH = 2,
  INTERVAL_GRANULARITY_WEEK = 3,
  INTERVAL_GRANULARITY_DAY = 4,
  INTERVAL_GRANULARITY_HOUR = 5,
  INTERVAL_GRANULARITY_MINUTE = 6,
  INTERVAL_GRANULARITY_SECOND = 7
}

export interface TimeRangeHistogramResult {
  startAt: protobuf.timestamp | null;
  endAt: protobuf.timestamp | null;
  value: number;
}

export interface TimeRangeHistogramData {
  granularity: IntervalGranularity;
  counts: TimeRangeHistogramResult[];
  aggregate: number;
}

export interface Graph {
  data: TimeRangeHistogramData | null;
}

export interface PageRow {
  multiDatum: MultiDatum | null;
  /** Cluster ID to use if we were to access page insights for this page. */
  representativeClusterId: protobuf.int64;
}

export interface PageList {
  data: PageRow[];
}

export interface SearchieHistogramData {
  histogram: Histogram | null;
}

export interface SearchieEventFunnelData {
  funnel: Funnel | null;
}

export interface SearchieIndividual {
  id: protobuf.int64;
  displayName: string;
  email: string;
  numSessions: number;
  numEvents: number;
  lastCity: string;
  userAppKey: string;
}

export interface IndividualWithSearchCriteria {
  individual: SearchieIndividual | null;
  /** Segment definition that should be used when selecting this individual. */
  newSegmentDefinition: segment.SegmentDefinition | null;
}

export interface IndividualList {
  data: IndividualWithSearchCriteria[];
  countType: SearchieCountType;
}

export interface SearchieMostActiveUsersData {
  individualList: IndividualList | null;
}

export interface SearchieSegmentHealthData {
  currentGraphs: Graph[];
  pastGraphs: Graph[];
}

export interface SearchieTopPagesData {
  pageList: PageList | null;
  matchingEvents: boolean;
}

export interface SearchieMostCommonEntryPagesData {
  pageList: PageList | null;
}

export interface SearchieRageGradeData {
  /** frustrated session data */
  frustratedUsers: SearchUser[];
  /** time at which the org was last graded, zero if unable to fetch the value */
  updatedAt: protobuf.timestamp | null;
}

export interface SearchieActivitySummaryData {
  numMatchingIndividuals: protobuf.int64;
  averageNumEvents: number;
  averageActiveDuration: protobuf.duration | null;
}

export interface SearchieDailyActivesData {
  /** keyed off of SearchieDailyActivesFrequency values */
  currentGraphs: { [key: string]: Graph };
  /** keyed off of SearchieDailyActivesFrequency values */
  pastGraphs: { [key: string]: Graph };
}

export interface SearchieMatchingUsersData {
  users: SearchUser[];
  matchingCounts: SearchieCounts | null;
}

export interface SearchieTimeRangeCountsData {
  timeRange: segment.TimeRange | null;
  /** total counts always provided */
  totalCounts: SearchieCounts | null;
  /** if count matching was configured, matching counts will be set */
  matchingCounts: SearchieCounts | null;
}

export interface SearchieCounts {
  numUsers: protobuf.int64;
  numSessions: protobuf.int64;
  numEvents: protobuf.int64;
}

export interface SearchieSlowPagesData {
  pageList: PageList | null;
}

export interface ApiError {
  field: string;
  reason: cookerr.Reason;
  count: protobuf.int64;
  lastSeenAt: protobuf.timestamp | null;
}

export interface RateLimitCounts {
  uservarCount: protobuf.int64;
  eventCount: protobuf.int64;
  pagevarCount: protobuf.int64;
  elemvarCount: protobuf.int64;
  seenCount: protobuf.int64;
}

export interface CardinalityLimitCounts {
  uservarCount: protobuf.int64;
  eventNameCount: protobuf.int64;
  eventPropCount: protobuf.int64;
  pagevarCount: protobuf.int64;
  elemvarCount: protobuf.int64;
}

export interface SearchieApiErrorsData {
  customErrors: ApiError[];
  uservarErrors: ApiError[];
  rateLimitCounts: RateLimitCounts | null;
  cardinalityLimitCounts: CardinalityLimitCounts | null;
  pagevarErrors: ApiError[];
  elemvarErrors: ApiError[];
}

export interface SearchieUserTrendsCardData {
  currentGraph: Graph | null;
  pastGraph: Graph | null;
}

/** A single searchie user result. */
export interface SearchUser {
  indvId: protobuf.int64;
  appKey: string;
  displayName: string;
  email: string;
  lastMatchingPage: string;
  lastPage: string;
  numEvents: number;
  numSessions: number;
  numMatchingSessions: number;
  numMatchingOfflineEvents: number;
  lastMatchingEventPageOffset: number;
  lastMatchingEventStartAt: protobuf.timestamp | null;
  lastMatchingSessionStartAt: protobuf.timestamp | null;
  lastMatchingSessionDuration: protobuf.duration | null;
  lastMatchingSessionActiveDuration: protobuf.duration | null;
  lastMatchingSessionNumPages: number;
  lastMatchingSessionNumEvents: number;
  lastMatchingUserSessionId: string;
  lastMatchingUserSessionPageId: string;
  lastMatchingCity: string;
  lastMatchingIpAddress: string;
  lastMatchingLatLong: string;
  lastMatchingBrowser: string;
  lastMatchingDevice: string;
  lastMatchingOperatingSystem: string;
  lastMatchingPlatform: segment.Platform;
  lastMatchingCaptureSourceIntegration: string;
  /** non empty if last matching event is a custom event */
  lastMatchingEventName: string;
  /** non empty if last matching event is a custom event with vars */
  lastMatchingEventVars: vars.Var[];
  totalDuration: protobuf.duration | null;
  totalActiveDuration: protobuf.duration | null;
  averageSessionDuration: protobuf.duration | null;
  averageActiveDuration: protobuf.duration | null;
  vars: vars.Var[];
  /** If fetch clips is set, the client will need to execute a SearchSessions request for each user. */
  fetchClips: boolean;
  /** If set, playing the session will require fetching the clip so we can highlight the correct events. */
  fetchSessionMarkers: boolean;
  createdAt: protobuf.timestamp | null;
}
